import classnames from 'classnames';
import { Calendar } from 'antd';
import moment from 'moment';
import React from 'react';
import styles from './left.module.scss';
import { isToday } from '../../miniCalendar';
import scheduleTracker from '../../tracker';
import { getIn18Text } from 'api';
const FORMAT_STR = 'YYYY-MM-DD';
moment.locale('en', {
    weekdaysMin: getIn18Text('RI_YI_ER').split('_'),
});
moment.locale('zh-cn');
const Left = ({ loading, setLoading, selectedDay, setSelectedDay, addSchedule }) => {
    const isSelectedDay = time => selectedDay.isSame(time);
    const isMonth = time => selectedDay.month() === time.month();
    const dateFullCellRender = value => {
        const date = value.date();
        return (React.createElement("div", { className: classnames(styles.miniDay, {
                [styles.today]: isToday(value) && !isSelectedDay(value),
                [styles.todaySelected]: isToday(value) && isSelectedDay(value),
                [styles.notTodaySelected]: !isToday(value) && isSelectedDay(value),
                [styles.notMonth]: !isMonth(value),
            }) }, date));
    };
    const prevMonth = e => {
        const prev = selectedDay.clone().subtract(1, 'M').date(1).format(FORMAT_STR);
        setSelectedDay(moment(prev));
        e.stopPropagation();
    };
    const nextMonth = e => {
        const next = selectedDay.clone().add(1, 'M').date(1).format(FORMAT_STR);
        setSelectedDay(moment(next));
        e.stopPropagation();
    };
    const headerRender = () => (React.createElement("div", { className: styles.miniHeader },
        React.createElement("span", { className: styles.miniMonth }, selectedDay.format(getIn18Text('YYYYNIANMMYUE'))),
        React.createElement("i", { className: classnames(styles.arrow, styles.left), onClick: e => {
                prevMonth(e);
            } }),
        React.createElement("i", { className: classnames(styles.arrow, styles.right), onClick: e => {
                nextMonth(e);
            } })));
    const onAdd = () => {
        const hour = moment().hour();
        addSchedule(true, hour);
        scheduleTracker.scheduleContact({
            action: 'create',
            type: 'create_button',
        });
    };
    const onChange = date => {
        setSelectedDay(date);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.outer },
            React.createElement("div", { className: styles.header },
                React.createElement("button", { type: "button", onClick: () => {
                        onAdd();
                    }, className: classnames('sirius-no-drag', styles.button) },
                    React.createElement("i", { className: styles.addIcon }),
                    React.createElement("span", { className: styles.text }, getIn18Text('XINJIANRICHENGBtn'))),
                React.createElement("i", { onClick: () => setLoading(true), className: classnames('sirius-no-drag', styles.syncIcon, {
                        'sirius-spin': loading,
                    }) })),
            headerRender(),
            React.createElement("div", { className: styles.miniCalendar },
                React.createElement(Calendar, { fullscreen: false, headerRender: () => null, value: selectedDay, dateFullCellRender: dateFullCellRender, onChange: onChange })))));
};
export default Left;
